import { Component, ElementRef, Input, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters';
import { AppTextService } from '@fi-shared/app-text';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiPageCollapsableContentComponent } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.component';
import { DocumentModel } from '@fi-app/document/document.model';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-document-edit-sharing-selection',
    templateUrl: './sharing-selection.component.html',
    styleUrls: ['./sharing-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: FiComponentsContainer, useExisting: DocumentEditSharingSelectionComponent }],
    host: { class: 'fi-document-edit-sharing-selection' },
    standalone: false,
})
export class DocumentEditSharingSelectionComponent extends FiComponentsContainer {
    @Input() document: DocumentModel;
    @ViewChild('accessRightFilters', { static: false }) accessRightFilters: AccessRightFiltersComponent;
    @ViewChild(FiPageCollapsableContentComponent, { static: false })
    pageCollapsableContentComponent: FiPageCollapsableContentComponent;

    selectedSelectionTitle: string;

    AccessRightFilterSettings = new AccessRightFilterSettings(ModuleType.Document, false, true, ObjectTypes.Document);

    constructor(
        private appTextService: AppTextService,
        private zone: NgZone,
        public elementRef: ElementRef,
    ) {
        super();
    }

    updateSelectedSelectionTitle(selectionTitle) {
        this.selectedSelectionTitle = selectionTitle;
    }

    isTooltipHidden() {
        return this.pageCollapsableContentComponent ? !this.pageCollapsableContentComponent.rollupContent.opened : true;
    }

    openSharingSelection(): Promise<any> {
        return new Promise((resolve) => {
            //this.accessRightFilters.SelectTabManual();
            this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.pageCollapsableContentComponent.rollupContent.openContent().then(resolve);
                });
            });
        });
    }
}
